import { DatePipe } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Store } from '@ngrx/store';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { combineLatest, Observable, Subscription } from 'rxjs/index';
import { filter, map, share, switchMap, tap } from 'rxjs/operators';
import { MissedRecallAction } from './state/missed-recall-action.service';
import { EscalatingReportSearchParams } from './state/missed-recall-report.model';
import { MissedRecallSelectors } from './state/missed-recall-selectors.service';
import { EscalatingReportState } from './state/missed-recall.reducer';

// TODO: Keep the jobId in the state so on next load of the page we'll know if we need to get report from backend again
// TODO: Consider if we should keep both a missed and a recall report in state
// TODO: Do not start loading messages in messaging details until the tab is opened

/**
 * Container component
 */
@Component({
    selector: 'missed-recall-report',
    templateUrl: './missed-recall-report.component.html'
})
export class MissedRecallReportComponent implements OnInit, OnDestroy {

    selectedTab = 'inProgress'; // TODO: Get this from router (so we should put tab name in route)
    private subscriptions: Subscription = new Subscription();

    fromDate$: Observable<Date>;
    reports$: Observable<EscalatingReportState>;
    loading$: Observable<boolean>;
    jobId$: Observable<number>;
    // angularJS to Angular upgrade is not sharing router params - so we need to get as input
    @Input() job: number;
    jobId: number;

    constructor(
        private store: Store<any>,
        private route: ActivatedRoute,
        private missedAndRecallSelector: MissedRecallSelectors,
        private datePipe: DatePipe) { // TODO: Use ngx-moment?

        this.reports$ = this.missedAndRecallSelector.selectReports()
            .pipe(
                filter(reports => reports !== undefined)
            );

        this.loading$ = this.missedAndRecallSelector.selectLoadingState();

        this.fromDate$ = this.missedAndRecallSelector.selectFromDateState()
            .pipe(
                filter(date => date !== undefined && date !== null)
            );
    }

    ngOnInit(): void {
        this.jobId$ = this.route.queryParamMap // this.route.paramMap
            .pipe(
                filter(params => params !== undefined),
                map(params => {
                    // NOTE (JACOB Feb 2021): The route params does in fact include job id)
                    // this.jobId = +params.get('jobid');
                    this.jobId = this.job;

                    return this.job;
                    }),
                filter(jobId => jobId > 0)
            );

        // TODO: Consider letting an effect request a new report from backend - but then refresh for same date needs to emit getEscalateReport directly
        // TODO: https://medium.com/@m3po22/stop-using-ngrx-effects-for-that-a6ccfe186399
        const subscription = combineLatest([this.fromDate$, this.jobId$])
            .subscribe(([date, jobId]) => {
                const searchParameters: EscalatingReportSearchParams = {
                    jobId,
                    dateFrom: this.datePipe.transform(date, 'yyyy-MM-dd') // TODO: Move transform to effect/service since it's an API detail
                };
                this.store.dispatch(MissedRecallAction.getEscalateReport({searchParameters}));
            });

        this.subscriptions.add(subscription);

    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Called by child filter component, while keeping the control in this container component
     * NOTE: When the filter component is initialised it will trigger onDateChange
     */
    onDateChange(selectedDate: Date): void {
        this.store.dispatch(MissedRecallAction.setFromDate({fromDate: selectedDate}));
    }

    onTabSelect(selectedTab: TabDirective): void {
        this.selectedTab = selectedTab.id;
    }
}
